if (!customElements.get('details-tabs')) {
  class DetailsTabs extends HTMLElement {
    constructor() {
      super();

      this.barsMobile = this.querySelectorAll('[data-bar-mobile]');
      this.barsDesktop = this.querySelectorAll('[data-bar-desktop]');
      this.contents = this.querySelectorAll('[data-content]');
      this.switches = this.querySelectorAll('[data-switch]');
      this.toggle = this.querySelector('.details-tabs__toggle');
      this.additionalBars = this.querySelector('[data-additional]');
      this.showMoreBars = this.querySelector('[data-show-more]');

      this.initTabs();
      this.bindSwitches();
      this.initShowMore();
      this.initDefaultState();
    }

    getActiveIndex() {
      const activeContentIndex = Array.from(this.contents).findIndex(content =>
        content.hasAttribute('data-active')
      );
      return activeContentIndex >= 0 ? activeContentIndex : 0;
    }

    setActiveIngredient(index) {
      this.barsMobile.forEach(el => el.removeAttribute('data-active'));
      this.barsDesktop.forEach(el => el.removeAttribute('data-active'));
      this.contents.forEach(el => el.removeAttribute('data-active'));

      if (this.barsMobile[index]) {
        this.barsMobile[index].setAttribute('data-active', '');
      }
      if (this.barsDesktop[index]) {
        this.barsDesktop[index].setAttribute('data-active', '');
      }
      if (this.contents[index]) {
        this.contents[index].setAttribute('data-active', '');
      }

      this.updateSwitchesForActiveIngredient(true);
    }

    getSwitchTabIndex(sw) {
      const tabIndex = Number(sw.dataset.tabIndex);
      return Number.isNaN(tabIndex) ? null : tabIndex;
    }

    getAvailableTabs(activeContent) {
      if (!activeContent) return [];

      const availableTabs = new Set();
      activeContent.querySelectorAll('[data-description]').forEach(desc => {
        const idx = Number(desc.dataset.index);
        if (!Number.isNaN(idx)) {
          availableTabs.add(idx);
        }
      });

      return Array.from(availableTabs).sort((a, b) => a - b);
    }

    setActiveDescription(tabIndex) {
      const activeIndex = this.getActiveIndex();
      const activeContent = this.contents[activeIndex];
      if (!activeContent) return;

      const availableTabs = this.getAvailableTabs(activeContent);
      if (availableTabs.length === 0) {
        this.switches.forEach(sw => sw.removeAttribute('data-active'));
        activeContent.querySelectorAll('[data-description]').forEach(desc => desc.removeAttribute('data-active'));
        return;
      }

      const nextTabIndex = availableTabs.includes(tabIndex) ? tabIndex : availableTabs[0];

      this.switches.forEach(sw => {
        const switchTabIndex = this.getSwitchTabIndex(sw);
        sw.toggleAttribute('data-active', switchTabIndex === nextTabIndex);
      });

      activeContent.querySelectorAll('[data-description]').forEach(desc => {
        desc.toggleAttribute('data-active', Number(desc.dataset.index) === nextTabIndex);
      });
    }

    updateSwitchesForActiveIngredient(resetActiveDescription = false) {
      const activeContent = this.contents[this.getActiveIndex()];
      const availableTabs = this.getAvailableTabs(activeContent);

      this.switches.forEach(sw => {
        const switchTabIndex = this.getSwitchTabIndex(sw);
        const isVisible = switchTabIndex !== null && availableTabs.includes(switchTabIndex);
        sw.toggleAttribute('hidden', !isVisible);
        if (!isVisible) {
          sw.removeAttribute('data-active');
        }
      });

      if (this.toggle) {
        this.toggle.toggleAttribute('hidden', availableTabs.length === 0);
        this.toggle.classList.toggle('details-tabs__toggle--single', availableTabs.length <= 1);
      }

      if (availableTabs.length === 0) {
        if (activeContent) {
          activeContent.querySelectorAll('[data-description]').forEach(desc => desc.removeAttribute('data-active'));
        }
        return;
      }

      const activeSwitch = Array.from(this.switches).find(sw => sw.hasAttribute('data-active') && !sw.hasAttribute('hidden'));
      const nextTabIndex = resetActiveDescription || !activeSwitch
        ? availableTabs[0]
        : this.getSwitchTabIndex(activeSwitch);

      this.setActiveDescription(nextTabIndex);
    }

    initTabs() {
      this.barsMobile.forEach((tab, i) => {
        tab.addEventListener('click', () => this.setActiveIngredient(i));
      });

      this.barsDesktop.forEach((tab, i) => {
        tab.addEventListener('click', () => this.setActiveIngredient(i));
      });
    }

    bindSwitches() {
      this.switches.forEach(sw => {
        sw.addEventListener('click', () => {
          if (sw.hasAttribute('hidden')) return;
          this.setActiveDescription(this.getSwitchTabIndex(sw));
        });
      });
    }

    initShowMore() {
      if (this.showMoreBars && this.additionalBars) {
        this.showMoreBars.addEventListener('click', () => {
          const isActive = this.additionalBars.hasAttribute('data-active');
          if (isActive) {
            this.additionalBars.removeAttribute('data-active');
            this.showMoreBars.removeAttribute('data-active');
          } else {
            this.additionalBars.setAttribute('data-active', '');
            this.showMoreBars.setAttribute('data-active', '');
          }
        });
      }
    }

    initDefaultState() {
      this.setActiveIngredient(this.getActiveIndex());
    }
  }

  customElements.define('details-tabs', DetailsTabs);
}
